import { client } from "@/config/client"

export interface Params {
  limit: number
  offset: number
  learningPathId: string
}

export interface Deck {
  cardsAmount: number
  id: string
  index: number
  name: string
}

export interface SetDeck {
  decks: Deck[]
  id: string
  name: string
  sourceType: "document" | "user_input" | "unknown"
  endPage?: number // Available for "document".
  startPage?: number // Available for "document".
}

export interface GetAllResponse {
  more: boolean
  sets: SetDeck[]
  other: SetDeck | null
}

const getAll = (params: Params) => {
  return client.get<GetAllResponse>("/v1/deck-sets", { params }).then((resp) => resp.data)
}

export default getAll
